/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_Lessons_EmptyInputs */

const en_student_lessons_empty = /** @type {(inputs: Student_Lessons_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No lessons yet.`)
};

const he_student_lessons_empty = /** @type {(inputs: Student_Lessons_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין שיעורים עדיין.`)
};

/**
* | output |
* | --- |
* | "No lessons yet." |
*
* @param {Student_Lessons_EmptyInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_lessons_empty = /** @type {((inputs?: Student_Lessons_EmptyInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_Lessons_EmptyInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_lessons_empty(inputs)
	return he_student_lessons_empty(inputs)
});